import React, { Component } from 'react'

import { Input } from 'components/Utils/Form'
import * as Icons from 'components/Utils/Icons'
import { MAX_INVITEES } from './Bulk'
import { Text } from 'components/base'

class ClassicInvitationsForm extends Component {
  onInputChange = index => event => {
    const { emails, setEmails } = this.props

    // Append new field if last field edition
    const lastFieldWasEdited =
      index === emails.length - 1 && emails[index].length === 0
    const hasReachedMaxInvitees = emails.length >= MAX_INVITEES

    const shouldAppendEmail =
      lastFieldWasEdited && hasReachedMaxInvitees === false
    const newEmails = [
      ...emails.slice(0, index),
      event.target.value,
      ...emails.slice(index + 1),
    ]
    setEmails(shouldAppendEmail ? newEmails.concat('') : newEmails)
  }

  onRemove = index => () => {
    const { emails, setEmails } = this.props
    setEmails([...emails.slice(0, index), ...emails.slice(index + 1)])
  }

  render() {
    return (
      <div>
        <Text.Section className="margin-bottom-normal">Email</Text.Section>
        {this.props.emails.map((email, index) => (
          <div key={index} className="position-relative margin-bottom-small">
            <Input
              value={email}
              placeholder="name@company.com"
              className="flexbox-grow flexbox flexbox-align-center width-full radius-normal border-small"
              onChange={this.onInputChange(index)}
              autoFocus={index === 0}
            />
            {index > 0 && (
              <div
                className="position-absolute padding-normal shade-30 shade-20-on-hover pointer flexbox flexbox-centered"
                style={{ height: '100%', right: 0, top: 0 }}
                onClick={this.onRemove(index)}
              >
                <Icons.CloseIcon size={12} />
              </div>
            )}
          </div>
        ))}
      </div>
    )
  }
}

export default ClassicInvitationsForm
